import { Icons, Stack, Typography } from '@healthinal/ui';
import { getAppointmentContact } from '../../../api/created/appointment.ts';
import { PatientBasicsDto, TaskDto } from '../../../api/generated/model';
import { SubCard } from '../../../components/SubCard.tsx';
import { formatDateTime } from '../../../utils/date.ts';
import { TaskCardTitle } from './TaskCardTitle.tsx';

export function TaskAppointmentCard({ task, patient }: { task: TaskDto; patient: PatientBasicsDto }) {
  const appointmentContact = getAppointmentContact(task.appointment);
  const patientName = [patient.firstName, patient.lastName].filter(Boolean).join(' ');

  return (
    <Stack direction={'row'}>
      <Stack flex={1} gap={2}>
        <Stack direction={'row'} gap={2}>
          <SubCard>
            <Icons.CalendarMonth size={'sm'} />
          </SubCard>
          <Stack justifyContent={'space-between'}>
            <TaskCardTitle task={task} />
            <Typography level={'body-sm'}>{formatDateTime(task.due)}</Typography>
          </Stack>
        </Stack>
        <Typography sx={{ whiteSpace: 'pre-line' }} level={'title-sm'}>
          {patientName}
        </Typography>
        <Typography level={'body-sm'}>
          Mitarbeiter: {appointmentContact?.firstName} {appointmentContact?.lastName}
        </Typography>
      </Stack>
    </Stack>
  );
}
